import React from 'react';
import '../style/userLayout.css';
import BreadCrumb from "./breadcrumb";
import { LAYOUT_FOOTER_TEXT_CA, LAYOUT_FOOTER_TEXT_UK, LAYOUT_FOOTER_TEXT_UK_LEI, PRIVACY_URL, WEBSITE_TERMS_OF_USE_URL, LINKEDIN_URL, YOUTUBE_URL, X_URL } from '../helpers/constants';
import { COUNTRY, CANADA_COUNTRY } from '../helpers/variables';
import { Footer, FormGroup } from 'arag-ui-lib';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';

let frontEndVersion = require('../helpers/version');

const LayoutFooter = (props) => {
	const {
		locationPathName,
		push,
		backEndVersion,
		legalEntityEnabled
	} = props;

	// WI 99937: CA wording is unaffected by the switch, same as EmailFooterResolver's CA no-op
	// (WI 99936) - CA text contains none of the strings the switch swaps. UK picks the ARAG
	// legal-entity (LEI) wording only when legalEntityEnabled is on; off (the default) keeps the
	// original "ARAG plc" wording unchanged.
	const registrationText = COUNTRY == CANADA_COUNTRY
		? LAYOUT_FOOTER_TEXT_CA
		: (legalEntityEnabled ? LAYOUT_FOOTER_TEXT_UK_LEI : LAYOUT_FOOTER_TEXT_UK);

	const socialArray = [
		{
			name: 'x',
			href: X_URL,
			title: CONTENT_STRINGS.X,
		},
		{
			name: "linkedin",
			href: LINKEDIN_URL,
			title: CONTENT_STRINGS.LINKEDIN,
		},
		{
			name: 'youtube',
			href: YOUTUBE_URL,
			title: CONTENT_STRINGS.YOUTUBE,
		}
	];

	const linksList = [
		{ element: <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">{CONTENT_STRINGS.PRIVACY_AND_COOKIES}</a> },
		{ element: <a href={WEBSITE_TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">{CONTENT_STRINGS.WEBSITE_TERMS_OF_USE}</a> }
	]

	return (
		<>
			<Footer
				socialArray={socialArray}
				linksList={linksList}
				registrationText={registrationText}
				breadcrumbs={
					<BreadCrumb
						PathName={locationPathName}
						Push={push}
						breadcrumbTestId={'footer-breadcrumb'}
					/>
				}
				footerTestId={'footer'}
			/>
			<div style={{display: 'flex', flexDirection: 'row'}}>
				<FormGroup
					variant={FORM_GROUP_VARIANTS.PLAIN}
					label={''}
					labelSize={'col-sm-12'}
					inputSize={'col-sm-12'}
					inputProps={{
						id: 'layout-frontend-version-info-id',
						name: 'layout-frontend-version-info-name',
						label: `FV:${frontEndVersion.version}`,
					}}
				/>
				<FormGroup
					variant={FORM_GROUP_VARIANTS.PLAIN}
					label={''}
					labelSize={'col-sm-12'}
					inputSize={'col-sm-12'}
					inputProps={{
						id: 'layout-backend-version-info-id',
						name: 'layout-backend-version-info-name',
						label: `BV:${backEndVersion}`,
					}}
					formGroupTestId={'footer-backend-version-info'}
				/>
			</div>
		</>
	);
};


export default LayoutFooter;